import * as tslib_1 from "tslib";
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '../../../core';
var FormlyWrapperFieldset = (function (_super) {
    tslib_1.__extends(FormlyWrapperFieldset, _super);
    function FormlyWrapperFieldset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyWrapperFieldset;
}(FieldWrapper));
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyWrapperFieldset.prototype, "fieldComponent", void 0);
FormlyWrapperFieldset = tslib_1.__decorate([
    Component({
        selector: 'formly-wrapper-fieldset',
        template: "\n    <div class=\"form-group\" [ngClass]=\"{'has-danger': showError}\">\n      <ng-container #fieldComponent></ng-container>\n    </div>\n  ",
    })
], FormlyWrapperFieldset);
export { FormlyWrapperFieldset };
//# sourceMappingURL=fieldset.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/fieldset.js
// module id = 783
// module chunks = 3